import React from 'react'

import { Box } from '@mui/material'
import WOStatusFilterMenuButton from './work-order-status-filter/FiltersMenuButton'
import ServiceFilterMenuButton from './service-filter/FiltersMenuButton'
import RouteFilterMenuButton from './route-filter/FiltersMenuButton'

const Filters = () => (
  <Box display="flex" alignItems="center" gap={1}>
    <ServiceFilterMenuButton />
    <RouteFilterMenuButton />
    <WOStatusFilterMenuButton />
  </Box>
)

export default Filters
